import {writable} from 'svelte/store';

const ALERTS = {
    NOTHING: null,
    ALERT: 1,
    CONFIRM: 2,
    DELETE: 3,
    WARNING: 4,
    CONFIRM_EXIT: 5,
}

const {set, update, subscribe} = writable({
    type: ALERTS.NOTHING,
    title: null,
    prompt: null,
    yes_callback: null,
    no_callback: null,
    icon: null,
});

const displayMessage = (type, title, prompt, yes_callback = null, no_callback = null) => {
    update(state => {
        state.type = type;
        state.title = title;
        state.prompt = prompt.replaceAll("\n", "<br>");
        state.yes_callback = yes_callback;
        state.no_callback = no_callback;
        return state;
    })
}

const Alert = {
    set, update, subscribe,
    alert: (title, prompt, ok_callback = null) => {
        displayMessage(ALERTS.ALERT, title, prompt, ok_callback);
    },
    confirm: (title, prompt, yes_callback = null, no_callback = null) => {
        displayMessage(ALERTS.CONFIRM, title, prompt, yes_callback, no_callback);
    },
    delete: (title, prompt, yes_callback = null, no_callback = null) => {
        displayMessage(ALERTS.DELETE, title, prompt, yes_callback, no_callback);
    },
    warning: (title, prompt, ok_callback = null) => {
        displayMessage(ALERTS.WARNING, title, prompt, ok_callback);
    },
    confirmExit: (title, prompt, yes_callback = null, no_callback = null) => {
        displayMessage(ALERTS.CONFIRM_EXIT, title, prompt, yes_callback, no_callback);
    },
    hide: () => {
        update(state => {
            state.type = ALERTS.NOTHING;
            state.title = null;
            state.prompt = null;
            state.yes_callback = null;
            state.no_callback = null;
            return state;
        })
    }
}
export default Alert;

export {ALERTS};